import React, { ReactNode, useState, useEffect } from 'react';
import styled from 'styled-components';
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import { OutboundLink } from "gatsby-plugin-google-analytics"
import { BaseButton, IconContainer } from '../../Header/components/Button'
import { ESC } from "../../../utils/keyCodes"
import CloseSVG from '../../Svg/Close'

export interface StoryItemProps {
  xPos?: string,
  yPos?: string,
  heightPercentage?: string,
  widthPercentage?: string,
  children?: ReactNode,
  className?: string,
  handleHover?: (event: any) => void,
  onClick?: (event?: any) => void,
  to?: string,
  direction?: string,
  href?: string,
  isVideo?: boolean,
}


const VideoContainer = styled.div`
  width: 100%;
  height: 100%;

  .overlay {
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .close-button {
    display: none;
  }

  &.active {
    .overlay {
      display: none;
    }

    .close-button {
      position: absolute;
      display: block;
      top: 0;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
`

const ClickOverlay = ({ children, active, onActive }) => {
  
  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent) => {
      if (event.keyCode === ESC) {
        onActive(false)
      }
    }

    if (active) {
      document.addEventListener("keydown", handleKeydown, false);
      try {
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({'event': 'buttonClick', 'category': 'haustradstefna', 'action': 'success',  'label': "video_expo"});
      } catch { }
    } else {
      document.removeEventListener("keydown", handleKeydown, false)
    }
    return () => {
      document.removeEventListener("keydown", handleKeydown, false)
    }
  }, [active])

  
  return (
    <VideoContainer className={active && 'active'}>
      <div className="overlay" onClick={() => onActive(true)}></div>

      <BaseButton onClick={() => onActive(false)} className="close-button">
        <IconContainer>
          <CloseSVG fill="#303030" width="25px" className="button-close" />
        </IconContainer>
      </BaseButton>

      {children}
    </VideoContainer>
  )
}

export default ({
  xPos,
  yPos,
  heightPercentage,
  widthPercentage,
  children,
  className,
  handleHover,
  onClick,
  to,
  direction = "right",
  href,
  isVideo
}: StoryItemProps) => {

  if (to) {
    return (
      <StyledAniLink
        swipe
        direction={direction}
        top="exit"
        to={to}
        entryOffset={110}
        className={className}

        style={{
          // backfaceVisibility: "hidden",
          transform: "translate3d(0,0,5px)",
          pointerEvents: 'auto',
          position: 'absolute',
          height: heightPercentage,
          width: widthPercentage,
          top: yPos ? yPos : `auto`,
          left: xPos ? xPos : `auto`,
          background: 'white',

        }}

        onMouseEnter={handleHover}
      >
        {children}
      </StyledAniLink>
    )
  }

  if (href) {
    return (
      <StyledOutboundLink
        href={href}
        target="_blank"
        className={className}

        style={{
          // backfaceVisibility: "hidden",
          transform: "translate3d(0,0,5px)",
          pointerEvents: 'auto',
          position: 'absolute',
          height: heightPercentage,
          width: widthPercentage,
          top: yPos ? yPos : `auto`,
          left: xPos ? xPos : `auto`,
          background: 'white',
        }}

        onClick={onClick}
        onMouseEnter={handleHover}
      >
        {children}
      </StyledOutboundLink>
    )
  }

  const [videoActive, setVideoActive] = useState(false)
  if (isVideo) {
    return (
      <Item
        className={className}
        heightPercentage={heightPercentage}
        widthPercentage={widthPercentage}
        xPos={xPos}
        yPos={yPos}

        // onMouseEnter={handleHover}

        style={{
          transform: videoActive && "translate3d(40%,0,4200px)",
          transition: "transform 0.3s ease-in",
          background: "transparent"
        }}
      >
        <ClickOverlay
          active={videoActive}
          onActive={isActive => setVideoActive(isActive)}
        >
          {children}
        </ClickOverlay>
      </Item>
    )
  }

  return (
    <Item
      className={className}
      heightPercentage={heightPercentage}
      widthPercentage={widthPercentage}
      xPos={xPos}
      yPos={yPos}

      onMouseEnter={handleHover}
    >
      {children}
    </Item>
  )
}

interface ItemProps {
  xPos,
  yPos,
  heightPercentage,
  widthPercentage,
}

const Item = styled.div<ItemProps>`
  height:${({ heightPercentage }) => heightPercentage};
  width:${({ widthPercentage }) => widthPercentage};
  pointer-events:auto;
  position:absolute;
  transform: translate3d(0,0,5px);

	top: ${({ yPos }) => yPos ? yPos : `auto`};
  left:${({ xPos }) => xPos ? xPos : `auto`};
	background: grey;
  transition: transform 0.3s ease-in;

	&.tiltOnHover:hover{
		transform: rotate3d(0, 1, 0, 25deg) translate3d(0,0,22vh) !important;
		transition:transform 0.3s ease-in;
	}
`

const StyledAniLink = styled(AniLink)`
	transition: transform 0.3s ease-in;
  &.tiltOnHover:hover{
		transform: rotate3d(0, 1, 0, 25deg) translate3d(0,0,22vh) !important;
		transition:transform 0.3s ease-in;
	}
`

const StyledOutboundLink = styled(OutboundLink)`
  transition: transform 0.3s ease-in;
	&.tiltOnHover:hover{
		transform: rotate3d(0, 1, 0, 25deg) translate3d(0,0,22vh) !important;
		transition:transform 0.3s ease-in;
	}
`